/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined'
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined'
import ApprovalOutlinedIcon from '@mui/icons-material/ApprovalOutlined'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined'
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined'
import {RootState} from '../../../../setup'
import {useSelector} from 'react-redux'
import { Languages } from './Languages'

const HeaderUserMenu: FC = () => {
  const authState = useSelector((state: RootState) => state.auth)
  
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <p className='menu-link px-3'>
          <PermIdentityOutlinedIcon /> <span className='nav-menu'>{authState?.fullName}</span>
        </p>
      </div>

      <div className='menu-item px-3'>
        <p className='menu-link px-3'>
          <AccountTreeOutlinedIcon /> <span className='nav-menu'>{authState?.divisionName}</span>
        </p>
      </div>

      <div className='menu-item px-3'>
        <p className='menu-link px-3'>
          <ApprovalOutlinedIcon /> <span className='nav-menu'>{authState?.companyName}</span>
        </p>
      </div>

      <div
        className='menu-item px-3'
        // data-kt-menu-trigger='hover' 
        // data-kt-menu-placement='left-start'
        // data-kt-menu-flip='bottom'
      >
        <p className='menu-link px-3'>
          <EmailOutlinedIcon /> <span className='nav-menu'>{authState?.userName}</span>
        </p>
        {/* <a href='#' className='menu-link px-3'>
          <span className='menu-title'>My Subscription</span>
          <span className='menu-arrow'></span>
        </a> */}

        {/* <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-3'>
              Referrals
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-3'>
              Billing
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-3'>
              Payments
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link d-flex flex-stack px-5'>
              Statements
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='View your statements'
              ></i>
            </a>
          </div>

          <div className='separator my-2'></div>

          <div className='menu-item px-3'>
            <div className='menu-content px-3'>
              <label className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input w-30px h-20px'
                  type='checkbox'
                  value='1'
                  defaultChecked={true}
                  name='notifications'
                />
                <span className='form-check-label text-muted fs-7'>Notifications</span>
              </label>
            </div>
          </div>
        </div> */}
      </div>

      <div className='menu-item px-3'>
        <a className='menu-link px-3'>
          <ContactPhoneOutlinedIcon /> <span className='nav-menu'>{authState?.phone}</span>
        </a>
      </div>

      <div className='menu-item px-3'>
        <Link to='/crafted/qr-code' className='menu-link px-3'>
          <ShareOutlinedIcon /> <span className='nav-menu'>Link liên kết</span>
        </Link>
        {/* <a href='' className='menu-link px-3'>
          <ShareOutlinedIcon /> <span className='nav-menu'>Link liên kết</span>
        </a> */}
      </div>

      <div className='menu-item px-3'>
        <a href='/auth/change-password' className='menu-link px-3'>
          <KeyOutlinedIcon /> <span className='nav-menu'>Đổi mật khẩu</span>
        </a>
      </div>

      <div className='separator my-2'></div>

      <Languages />

      {/* <div className='menu-item px-3 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-3'>
          Account Settings
        </Link>
      </div> */}

      <div className='menu-item px-3'>
        <Link to='/logout' className='menu-link px-3'>
          <LogoutOutlinedIcon /> <span className='nav-menu'>Đăng xuất</span>
        </Link>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
